import { useQuery } from '@tanstack/react-query';
import { adsListingService } from '../ads-listing.service';
import type { TUseAdDetailConfig, TUseAdDetailReturn } from './use-ad-detail.types';

/**
 * Hook para consultar detalhes de um anúncio
 *
 * @example
 * ```tsx
 * const { ad, isLoading, refetch } = useAdDetail({
 *   vehicleType: 'car',
 *   id: 12345,
 *   enabled: true
 * });
 * ```
 */
const useAdDetail = (config: TUseAdDetailConfig): TUseAdDetailReturn => {
	const { vehicleType, id, enabled = true } = config;

	const { data, isLoading, isError, error, refetch, isFetching } = useQuery({
		queryKey: ['ads', 'detail', vehicleType, id],
		queryFn: () => adsListingService.getAdDetail(vehicleType, id),
		enabled: enabled && !!id
	});

	return {
		ad: data,
		isLoading,
		isError,
		error: error as Error | null,
		refetch: () => {
			void refetch();
		},
		isFetching
	};
};

export { useAdDetail };
